//export const URL = 'http://localhost:5007/'  


export const SOCKET_URL = 'http://localhost:5007/'

//export const URL = 'http://192.168.1.183:5000/'

//export const URL = 'https://zunuodb.yourcareconnect.online/'

//export const URL = 'https://jitrockbd.yourcareconnect.online/'


//export const URL = 'https://rafchikdb.yourcareconnect.online/'


//export const URL = 'https://tepadb.yourcareconnect.online/'


//export const URL = 'https://delabhealthcareplazadb.yourcareconnect.online/'


//export const URL = 'https://jamesbertdb.yourcareconnect.online/'


//export const URL = 'https://ayimbaradb.yourcareconnect.online/'


//export const URL = 'https://shalomdb.yourcaresystem.online/'


export const URL = 'https://gigattapexdb.yourcaresystem.online/'


//export const URL = 'https://ginamedicalcentredb.yourcaresystem.online/'


//export const URL = 'https://emilmemorialhospitaldb.yourcaresystem.online/'



export const companyInfo = URL + 'companyInfo'

// ccc api configuration loading
export const apiConfigNhia = URL + 'api-config/nhia'


// Authentication endpoints
export const login = URL + 'login'
export const changepassword = URL + 'changepassword'
export const createstaff = URL + 'createstaff'
export const changestaffpassword = URL + 'changestaffpassword'

// First-run system setup (see backend/setup_routes.js).
// setup_status is the boot gate: while it reports setupRequired the app
// renders the Setup wizard and the login screen is never mounted.
export const setup_status             = URL + 'setup/status'
export const setup_username_available = URL + 'setup/username-available'
export const setup_validate_activation = URL + 'setup/validate-activation'
export const setup_complete           = URL + 'setup/complete'

// Forced password change at first login. Enforces the full password policy
// and clears first_login — the username is never touched.
export const first_password    = URL + 'account/first-password'
export const password_policy   = URL + 'account/password-policy'

// A signed-in user changing their own password. Replaces the old
// changestaffpassword call, which could never succeed from the dialog because
// it verified against trans_code but was only ever sent an email.
export const change_password   = URL + 'account/change-password'

// Which departments THIS facility subscribes to. The 35-department catalogue
// in data/department.js is the same for every install; this is the per-facility
// subset that admin screens filter to. See migration 030.
export const facility_departments = URL + 'facility/departments'

// Facility session policy — currently the idle-logout timeout, in minutes.
// Read by IdleLogout on every load; written from
// Admin Panel → System Settings → Session & Security.
export const security_settings = URL + 'system/security-settings'

// Pharmacy dispensing policy — whether the dispensary may see (and serve) a
// prescription before the patient has paid. Three modes: hide | view | serve.
// Read by the pharmacy list on every load and enforced again on the serve path,
// so a stale screen cannot dispense past the gate. Written from
// Admin Panel → System Settings → Pharmacy & Payment.
export const pharmacy_settings = URL + 'system/pharmacy-settings'


// Department
export const reg_department = URL + 'departments'
export const update_department = (id) => URL + `departments/${id}`
export const delete_department = (id) => URL + `departments/${id}`

// HOD 
export const reg_hod = URL + 'hod'
export const update_hod = (id) => URL + `hod/${id}`
export const delete_hod = (id) => URL + `hod/${id}`
export const reg_hod_access = URL + 'hod-access'

// HOD Assignment 
// HOD Assignment endpoints
export const get_all_hod_assignments = URL + 'hod-assignments'
export const get_hod_assignments = URL + 'get_hod-assignments'
export const assign_hod_access = URL + 'hod-assignments'
export const get_hod_asighment = URL + 'hod-assignments'

// Department Users 
export const reg_department_user = URL + 'department-users'
export const update_department_user = (id) => URL + `department-users/${id}`
export const delete_department_user = (id) => URL + `department-users/${id}`
export const get_designations = URL + 'designations'

export const get_user_access = URL + `user-access`

// Desig
export const reg_designation = URL + 'designations'
export const update_designation = (id) => URL + `designations/${id}`
export const delete_designation = (id) => URL + `designations/${id}`

// Role Management 
export const reg_roles = URL + 'roles'

// Access Management endpoints
export const get_hoa_access = URL + 'hoa-access'
export const get_available_access = (section) => URL + `all-access/${section}`

// Department Access Management
export const get_available_department_access = (hodId) => URL + `department-available-access/${hodId}`
export const get_user_assigned_access = (userId) => URL + `department-user-access/${userId}`
export const update_user_access = (userId) => URL + `department-user-access/${userId}`

// NFF Import endpoint
export const nff_import = URL + 'nff-import'

export const get_fee_items = (standard) => URL + `api/fee-items/${standard}`
export const save_fees = URL + 'api/save-fees'

export const get_department_staff = (department) => URL + `department-staff/${department}`
export const check_user_access = (userId) => URL + `check-user-access/${userId}`
export const get_assembly_info = URL + 'assembly-info'


//Role Management
export const newRole = URL + 'newRole'
export const LoadRoles = URL + 'LoadRoles'
export const updateRole = (id) => URL + `updateRole/${id}`
export const delete_Role = (id) => URL + `delete_Role/${id}`
// How many users / department permissions a rename or delete would touch.
export const roleImpact = (id) => URL + `roleImpact/${id}`


//System Users
export const NewUser = URL + 'NewUser'
export const LoadUsers = URL + 'LoadUsers'
export const UpdateUser = URL + 'UpdateUser'
export const DeleteUser = URL + 'DeleteUser'
export const UpdateUserStatus = URL + 'UpdateUserStatus'



//accessibledepartments
export const accessibledepartments = URL + 'accessibledepartments'
export const AddAccessibledepartments = URL + 'AddAccessibledepartments'
export const RemoveAccessibledepartments = URL + 'RemoveAccessibledepartments'
export const getAcc = URL + 'getAcc'



//Insurance
export const NewInsurance = URL + 'NewInsurance'
export const loadInsurance = URL + 'loadInsurance'
export const updateInsurance = (id) => URL + `updateInsurance/${id}`
export const newPolicy = URL + 'newPolicy'
export const loadpolicy = URL + 'loadpolicy'
export const updatePolicy = (id) => URL + `updatePolicy/${id}`
export const deleteInsurances = (id) => URL + `deleteInsurances/${id}`

export const deletePolicy = (id) => URL + `deletePolicy/${id}`

// Read-only preview of what a company rename would touch. The insurance name
// is stored as a string across ~27 columns rather than referenced by id, so
// renaming has to cascade — this reports the blast radius before it happens.
export const insuranceRenameImpact = (id, newName) =>
  URL + `insurance/${id}/rename-impact?newName=${encodeURIComponent(newName)}`


//Records
export const loadPatients = URL + 'loadPatients'
export const registrationsAnalisis = URL + 'registrationsAnalisis'
export const registrationsAggregated = URL + 'registrationsAggregated'


export const loadPatientsClaToday = URL + 'loadPatientsClaToday'
export const SavePatientInformation = URL + 'SavePatientInformation'
export const uploadPatient = URL + 'uploadPatient'

export const savePatienVitals = URL + 'savePatienVitals'

export const loadPatientsVitals = URL + 'loadPatientsVitals'

export const loadStayAt = URL + 'loadStayAt'


//Pharmacy
export const loadPharmacyPatients = URL + 'loadPharmacyPatients'
export const loadPharmacyPatientsMed = URL + 'loadPharmacyPatientsMed'
export const prescriptionServeAll = URL + 'prescriptionServeAll'
export const updateMedicationStatutt = (medicationId) => URL + `updateMedicationStatutt/${medicationId}`
export const notServedMedicationUrl = (id) => URL + `notServedMedication/${id}`;
export const loadPharmacyVitals = URL + 'loadPharmacyVitals'
export const loadPharmacyclinicalNotes = URL + 'loadPharmacyclinicalNotes'
export const loadPharmacyPatientsMedcount = URL + 'loadPharmacyPatientsMedcount'
export const loadPharmacyPatientsChart = URL + 'loadPharmacyPatientsChart'
export const loadPharmacyUserMed = URL + 'loadPharmacyUserMed'
export const loadPatientsMedHistory = URL + 'loadPatientsMedHistory'


//Bill 
export const loadAccountsPatients = URL + 'loadAccountsPatients'
export const loadPatientBill = URL + 'loadPatientBill'
export const billSummaryBulkdb = URL + 'billSummaryBulk'
export const PaymentProcess = URL + 'PaymentProcess'
export const patienHistory = URL + 'patienHistory'
export const DayIncome = URL + 'DayIncome'
export const reversal = URL + 'reversal'
export const loadReversalRequest =URL+'loadReversalRequest'
export const approvalReversal =URL+'approvalReversal'
export const disapprovalReversal =URL+'disapprovalReversal'
export const loadDebtAccount =URL+'loadDebtAccount'
export const loadDebtService =URL+'loadDebtService'
export const userTransaction =URL+'userTransaction'
export const getPendingReversalsdb    =  URL + 'getPendingReversals'
export const getAllPendingReversalsdb  = URL + 'getAllPendingReversals'
export const approveReversaldb    = URL + 'approveReversal';
export const disapproveReversaldb = URL+ 'disapproveReversal';


//bill me
export const loadBillMeService= URL + 'loadBillMeService'
export const SaveBillMe =URL+'SaveBillMe'
export const loadBillMeHistory =URL+'loadBillMeHistory'




export const initiatepayment = URL + 'initiatepayment'

export const checkpaymentstatus = (checkoutId) => URL + `checkpaymentstatus/${checkoutId}`


// Component Access endpoints
export const getComponentPermissions = (roleId, departmentId) => 
 URL + `api/component-access/component-permissions/${roleId}/${departmentId}`
export const updateComponentPermissions = URL + 'api/component-access/component-permissions'
export const getDepartmentComponents = (departmentId) => 
    URL + `api/component-access/department-components/${departmentId}`

// Accessible departments + their components + this role's granted permissions,
// in one request. Replaces the 1 + 2N sequential calls the Component Access
// screen used to make before it could render anything.
export const getRoleComponentMatrix = (roleId) =>
    URL + `api/component-access/role-matrix/${roleId}`

export const getUserDepartmentComponents = URL + 'getUserDepartmentComponents'

export const getAccessibleDepartments = (roleId) => URL + `getAccessibleDepartments/${roleId}`



//Doctors

export const AIsuggest =URL+'AIsuggest'
export const loadAllPatientsToday =URL+'loadAllPatientsToday'
export const loadInsuredServicesdb =URL+'loadInsuredServices'
export const loadDoctorSuggestionsdb =URL+'loadDoctorSuggestions'
export const loadPatientDiagnosisdb =URL+'loadPatientDiagnosis'
export const servicesToday =URL+'servicesToday'
export const saveServiceProvideddb =URL+'saveServiceProvided'
export const saveOrUpdateDiagnosisdb =URL+'saveOrUpdateDiagnosis'
export const loadDiagnosisOptionsdb =URL+'loadDiagnosisOptions'
export const loadProcedureOptionsdb =URL+'loadProcedureOptions'
export const saveOrUpdateDiagnosisDocumetingdb =URL+'saveOrUpdateDiagnosisDocumeting'
export const saveOrUpdateProceduresDocumetingdb =URL+'saveOrUpdateProcedureDocumeting'
export const loadLabdb =URL+'loadLabs'
export const requestLab =URL+'requestLab'
export const loadRequestedLabsdb =URL+'loadRequestedLabs'
export const deleteRequestedLabdb =URL+'deleteRequestedLab'
export const loadAvailableScansdb =URL+'loadAvailableScans'
export const loadRequestedScandb =URL+'loadRequestedScan'
export const loadMedicationsdb =URL+'loadMedications'
export const addMedicationdb =URL+'addMedication'
// A claim's dispensed medications. On a bureau install these live in
// claim_medications (6,630 rows from one April batch); the flat endpoint reads
// the `medication` table, which an XML import never touches.
export const loadRequestedMedsdb =URL+'claims/store/medications'
export const updateMedicationdb =URL+'updateMedication'
export const medicationdeletedb =URL+'deleteMedication'
export const loadOtherServicesdb =URL+'loadOtherServices'
export const requestOtherService =URL+'requestOtherService'
export const loadRequestedOtherServicesdb =URL+'loadRequestedOtherServices'
export const getPatientTimeline_medicalHistorydb =URL+'getPatientTimeline_medicalHistory'
export const getPatientVisitDetailsdb =URL+'getPatientVisitDetails'
export const getPatientTimeline_labHistory =URL+'getPatientTimeline_labHistory'
export const getPatientVisitDetailsLab =URL+'getPatientVisitDetailsLab'
export const getPatientTimeline_ScanHistory =URL+'getPatientTimeline_ScanHistory'
export const getPatientVisitDetailsScan =URL+'getPatientVisitDetailsScan'
export const getPatientVitalsHistorydb =URL+'getPatientVitalsHistory'
export const saveAppointmentdb = URL+'saveAppointment'
export const loadAppointmentsdb = URL+'loadAppointments'
export const updateAppointmentdb = URL+'updateAppointment'
export const deleteAppointmentdb = URL+'deleteAppointment'
export const getPatientAppointmentdb = URL+'getPatientAppointment'
export const admitPatient = URL+'admitPatient'
export const getTodayAppointments = URL+'getTodayAppointments'
export const loadMedicationByAge = URL+'loadMedicationByAge'
export const getAttendanceStats = URL+'getAttendanceStats'
export const getDiagnosisStats = URL+'getDiagnosisStats'
export const loadAllInPatients = URL+'loadAllInPatients'
export const loadInPatientDiagnosis = URL+'loadInPatientDiagnosis'
export const loadWardRoundsdb = URL+'loadWardRounds'
export const loadDoctorSuggestionsInpatient = URL+'loadDoctorSuggestionsInpatient'
export const saveAdmissionInfoRound = URL+'saveAdmissionInfoRound'
export const getPatientVitalsHistoryAdmission = URL+'getPatientVitalsHistoryAdmission'
export const getPatientTimeline_labHistoryAdmission = URL+'getPatientTimeline_labHistoryAdmission'
export const getPatientTimeline_ScanHistoryAdmission = URL+'getPatientTimeline_ScanHistoryAdmission'
export const loadPatientsMedHistoryAdmission = URL+'loadPatientsMedHistoryAdmission'
export const outpatientStatsdb = URL+'outpatientStats'
export const inpatientStatsdb = URL+'inpatientStats'
export const savePrecautiondb = URL+'savePrecaution'
export const deleteOrReverseOtherServicedb = URL+'deleteOrReverseOtherService'
export const loadRequestedLabsInpatients = URL+'loadRequestedLabsInpatients'
export const loadRequestedScanInpatient = URL+'loadRequestedScanInpatient'
export const loadRequestedMedsInpatient = URL+'loadRequestedMedsInpatient'
export const loadRequestedOtherServicesInpatient = URL+'loadRequestedOtherServicesInpatient'
export const DischargePatient = URL+'DischargePatient'
export const DeadchargePatient = URL+'DeadchargePatient'
export const loadNurseWardAssignmentsdb = URL + 'loadNurseWardAssignments';
export const getNurseAssignedWardsdb    = URL + 'getNurseAssignedWards';
export const assignNurseToWarddb        = URL + 'assignNurseToWard';
export const removeNurseWardAssignmentdb = URL + 'removeNurseWardAssignment';
export const loadAllInPatientsWardFiltered = URL + 'loadAllInPatientsWardFiltered';
export const LoadUsersdb = URL + 'LoadUsers';


export const ReAdmitPatient = URL+'ReAdmitPatient'
export const saveChronicMedication = URL+'saveChronicMedication'
export const loadChronicMedicationdb = URL+'loadChronicMedication'
export const addWardWithBeds = URL+'addWardWithBeds'
export const loadNurseNotesdb = URL+'loadNurseNotes'
export const saveNurseNotedb = URL+'saveNurseNote'
export const deleteNurseNotedb = URL+'deleteNurseNotedb'
export const searchAllPatientsdb = URL + 'patientsSearch';


//Ward & Beds
export const loadBedsdb = URL+'loadBeds'
export const loadWardsdb = URL+'loadWards'
export const deleteWard = URL+'deleteWard'
export const deleteBed = URL+'deleteBed'
export const loadPendingPatientsdb = URL+'loadPendingPatients'
export const loadWards_bed = URL+'loadWards_bed'
export const loadBedsByWarddb = URL+'loadBedsByWard'
export const assignBedToPatient = URL+'assignBedToPatient'
export const erDirectAdmitdb    = URL+'erDirectAdmit'
export const transferERPatientdb = URL+'transferERPatient'
export const loadDetentionReviewsDuedb     = URL+'loadDetentionReviewsDue'
export const convertDetentionToAdmissiondb = URL+'convertDetentionToAdmission'
export const loadOccupancyStatsdb = URL+'loadOccupancyStats'
export const loadAllInPatientsWard = URL+'loadAllInPatientsWard'
export const loadVitalsHistorydb = URL+'loadVitalsHistory'
export const saveVitalsdb = URL+'saveVitals'
export const deleteVitalsdb = URL+'deleteVitals'
export const loadFBSHistorydb = URL+ 'loadFBSHistory';
export const saveFBSdb = URL +'saveFBS';
export const deleteFBSdb = URL+'deleteFBS';
export const loadRBSHistorydb = URL+ 'loadRBSHistory';
export const saveRBSdb = URL+ 'saveRBS';
export const deleteRBSdb = URL + 'deleteRBS';
export const loadInsurancesddb = URL + 'loadInsurances';
export const loadPatientMedicationsForChartdb = URL+ 'loadPatientMedicationsForChart';
export const saveChartedMedicationdb = URL+ 'saveChartedMedication';
export const loadChartedMedicationsdb = URL+ 'loadChartedMedications';
export const markMedicationAsServeddb = URL+ 'markMedicationAsServed';
export const deleteChartedMedicationdb = URL+ 'deleteChartedMedication';
export const getMedicationSheetHistorydb = URL+ 'getMedicationSheetHistory';
export const nurseDischargeBeddb = URL+ 'nurseDischargeBed';
export const updateWarddb = URL+ 'updateWard';
export const loadAvailableBedsdb = URL+ 'loadAvailableBeds';
export const transferPatientWardBeddb = URL+ 'transferPatientWardBed';
export const loadPatientCurrentBeddb = URL+ 'loadPatientCurrentBed';
export const checkPatientDischargeStatusbd = URL+ 'checkPatientDischargeStatus';
export const patientsByWarddb = URL+ 'patientsByWard';

 


// -----------------------------------------------------------------------------
//Procurement
export const loadProducts = URL + 'loadProducts'
export const loadProductDetails = URL + 'loadProductDetails'
export const addProduct = URL + 'addProduct'
export const removeProductInsurance = URL + 'removeProductInsurance'

export const updateProductInsurances =  URL + 'updateProductInsurances'
export const loadInventory = URL + 'loadInventory'
export const loadDispensaryProducts = URL + 'loadDispensaryProducts'
export const getProductStock = (productName) => URL + `getProductStock/${encodeURIComponent(productName)}`
export const saveRequisitions = URL + 'saveRequisitions'
export const getRequisitions = URL + 'getRequisitions'
export const updateRequisition = (id) => URL + `updateRequisition/${id}`
export const deleteRequisition = (id) => URL + `deleteRequisition/${id}`
export const productTrace = URL + 'productTrace'
export const deleteProduct = URL + 'deleteProduct'
export const processPurchase = URL + 'processPurchase'
export const loadProductsForPurchase = URL + 'loadProductsForPurchase'
export const deleteInventory = (trans_code) => URL + `deleteInventory/${trans_code}`

// Consumables (cotton, plaster, cannula, …) — separate catalogue with its
// own pack/loose stock model. Lives under Procurement → Consumables.
export const consumablesUrl              = URL + 'consumables';
export const consumableByIdUrl   = (id)  => URL + `consumables/${id}`;
export const consumableStockUrl  = (id)  => URL + `consumables/${id}/stock`;
// Consumable purchase orders — mirrors the drug processPurchase /
// loadInventory pair. The frontend "Purchase Orders - Consumables" page
// uses these three endpoints to list, receive, and reverse batches.
export const consumablePurchasesUrl        = URL + 'consumablePurchases';
export const processConsumablePurchaseUrl  = URL + 'processConsumablePurchase';
export const deleteConsumablePurchaseUrl   = (id) => URL + `deleteConsumablePurchase/${id}`;

// Consumable pricing (per-insurance) — mirrors drug pricing endpoints.
export const consumablePricingUrl          = URL + 'consumablePricing';
export const consumablePricingUpdateUrl    = URL + 'consumablePricing/update';

// Consumable stock analysis — roll-up + per-batch detail for the analytics page.
export const consumableStockAnalysisUrl    = URL + 'consumableStockAnalysis';
export const consumableBatchesByIdUrl      = URL + 'consumableBatches';

// Store Pricing APIs

export const loadProductPricing = URL + 'storepricing';

export const storePricingURL = URL + 'api/store-pricing';
export const updateProductPricing = URL + 'api/store-pricing/update'
export const loadStockAnalysis  = URL + 'stockAnalysis'
export const loadInventoryBatches = URL + 'inventoryBatchesCode';
export const adjustStock = URL + 'adjustStock';

// Audit trail
export const auditLogs             = URL + 'auditLogs';

// Sub-branches (multi-tenancy)
export const branchesRequest = URL + 'branches/request';
export const branchesList    = URL + 'branches';
export const branchesApprove = URL + 'branches/approve';
export const branchesReject  = URL + 'branches/reject';
export const branchesSuspend = URL + 'branches/suspend';

// Pharmacy attention (forces pharmacists to resolve every prescription)
export const pharmacyAttentionOpen    = URL + 'pharmacy/attention/open';
export const pharmacyAttentionPending = URL + 'pharmacy/attention/pending';
export const pharmacyAttentionResolve = URL + 'pharmacy/attention/resolve';

// Admission Compliance (vitals + nursing notes per-day rule)
export const complianceSettings    = URL + 'complianceSettings';
export const admissionCompliance   = URL + 'admissionCompliance';
export const complianceViolations  = URL + 'complianceViolations';
export const complianceFollowup    = URL + 'compliance/followup';
export const complianceFollowups   = URL + 'compliance/followups';
export const complianceFollowupDismiss = (id) => URL + `compliance/followup/${id}/dismiss`;

// Database backup — admin-gated full DB dump (streamed as .sql.gz)
export const downloadDatabaseBackup = URL + 'downloadDatabaseBackup';

export const notifyPharmacyRestock  = URL + 'notifyPharmacyRestock';
export const getRestockNotifications = URL + 'getRestockNotifications';
export const markRestockSeen         = URL + 'markRestockSeen';

//  --------------------------------------------------------------------------------------
 


// Laboratory
export const loadHaematologyParameters = URL + 'loadHaematologyParameters'
export const addLabCategory = URL + 'addLabCategory'
export const loadLabCategories = URL + 'loadLabCategories'
export const deleteLabCategory = (id) => URL + `deleteLabCategory/${id}`
export const updateLabCategory = (id) => URL + `updateLabCategory/${id}`
export const addLabParameters = URL + 'addLabParameters'
export const updateLabParameter = (transCode) => URL + `updateLabParameter/${transCode}`
export const deleteLabParameter = (transCode) => URL + `deleteLabParameter/${transCode}`
export const deleteResultC = (transCode) => URL + `deleteResult/${transCode}`



// ==========================================
// NEW ENDPOINTS FOR LABORATORY MY PATIENTS
// ==========================================
export const loadLabPatients = URL+'loadLabPatients'
export const loadLabRequestsOutpatient = URL+'loadLabRequestsOutpatient'
export const loadLabRequestsInpatient = URL+'loadLabRequestsInpatient'
export const loadLabTestParameters = URL + `loadLabTestParameters`
export const loadParameterDetails =  URL + `loadParameterDetails`
export const saveLabResults = URL + 'saveLabResults'


 

export const loadLabResults = URL + 'loadLabResults'
export const labhistoryLoad = URL + 'labhistoryLoad'
export const loadLabHistory = URL + 'loadLabHistory'
export const loadLabResultsByPath = URL + 'loadLabResultsByPath'
export const getLabSummaryToday = URL + 'getLabSummaryToday'
export const getLabRequestsToday = URL + 'api/getLabRequestsToday'

// ==========================================
// SCAN ENDPOINTS FOR LABORATORY
// ==========================================
export const loadScanPatients = (state = 'all') => URL + `loadScanPatients?state=${state}`
export const loadScanRequestsOutpatient = URL + 'loadScanRequestsOutpatient'
export const loadScanRequestsInpatient = URL + 'loadScanRequestsInpatient'
// ==========================================
// SCAN MANAGEMENT ENDPOINTS
// ==========================================
export const loadDistinctScans = () => URL + `loadDistinctScans`
export const loadScanParameters = (scanName) => URL + `loadScanParameters/${encodeURIComponent(scanName)}`
export const loadAllScansWithParameters = () => URL + `loadAllScansWithParameters`
export const saveScanResults = URL + 'saveScanResults'
export const loadExistingScanResults = URL + 'loadExistingScanResults'
export const loadPatientScanReport = URL + 'loadPatientScanReport'
export const loadPatientLabReport = URL + 'loadPatientLabReport'
export const getScanSummaryToday = URL + 'getScanSummaryToday'
export const getTodayScanRequests = URL + 'getTodayScanRequests'

// SCAN MANAGEMENT CRUD ENDPOINTS
export const addScanCategory = URL + 'addScanCategory'
export const updateScanCategory = (oldScanName) => URL + `updateScanCategory/${encodeURIComponent(oldScanName)}`
export const deleteScanCategory = (scanName) => URL + `deleteScanCategory/${encodeURIComponent(scanName)}`
export const addScanParameter = URL + 'addScanParameter'
export const updateScanParameter = (id) => URL + `updateScanParameter/${id}`
export const deleteScanParameter = (id) => URL + `deleteScanParameter/${id}`

// for report
export const loadPharmacyInfo = URL + 'companyInfo'
export const loadPatientLabResultsToday = URL + 'loadPatientLabResultsToday'
export const loadPatientScanResultsToday = URL + 'loadPatientScanResultsToday'
export const loadPatientDocumentation = URL + 'loadPatientDocumentation'
export const DHimsperiods = URL + 'DHimsperiods'
export const patient_inflow = URL + 'patient_inflow'
export const patient_inflow_inpatient = URL + 'patient_inflow_inpatient'
export const monthlyOpdMorbidity = URL + 'monthlyOpdMorbidity'
export const monthlyLabResults   = URL + 'monthlyLabResults'
export const monthlySurgicalOperations = URL + 'monthlySurgicalOperations'



//claims
//
// These four point at /claims/store/* rather than the endpoints they are named
// after. That is deliberate, and it is the whole reason claimStore.js exists.
//
// A facility install stores claims in the flat claim_information table; a Gigatt
// Apex (bureau) install stores them in the normalised claims tables the NHIA XML
// importer writes to. The old endpoints only ever read claim_information, so on a
// bureau install an imported batch of claims was invisible to the very screens
// meant to work on it.
//
// /claims/store/* reads whichever table this installation actually uses, chosen
// from the install profile set during setup, and returns byte-identical shapes
// either way — same field names, same JS types, same ordering. So every consumer
// here (HospitalClaims, ClaimsDetails, ClaimsReport) keeps working unchanged, and
// a hospital sees exactly what it saw before.
//
// The original endpoints are still live and unmodified. If anything about this
// misbehaves, changing these four lines back is the entire rollback.
export const insurancetypes = URL +'claims/store/schemes'
export const claimmonths = URL +'claims/store/months'
export const claimdatesbymonth = URL +'claims/store/dates'
// These four fill the worklist's content-filter dropdowns. Repointed for the
// same reason as the rest: on a bureau install the flat versions read tables that
// hold none of the imported data, so every filter would offer an empty list.
export const claimServices = URL +'claims/store/options/services'
export const claimDiagnosis = URL +'claims/store/options/diagnoses'
export const claimprocedures = URL +'claims/store/options/procedures'
export const claimmedications = URL +'claims/store/options/medications'
export const claimpatients = URL +'claims/store/worklist'

// Which store the Claims screens are reading, and what is in it. Used to label
// the interface and to answer "where did my claims go" without guessing.
export const claimStoreModel = URL +'claims/store/model'

// One claim in full — header, diagnoses, procedures, investigations, medications
// and the cost rollups. Feeds the editor that drops open inline under a row in
// the Claims Menu. ?id= plus ?source= ('facility' | 'imported'), because a flat
// claim is addressed by the composite 'patientId::date' and an imported one by
// its row id.
export const claimStoreDetail = URL +'claims/store/detail'

// Entries ▸ Documentation ▸ Generate. POST { id, source, includeOther } -> a
// plain-language complaint / history / examination written from what is actually
// on the claim. Sends only the claim's identity: the backend re-reads the claim
// itself, so the note cannot describe a context the browser made up.
// Behind the AI licence, like the Templates suggestions. 422 means the claim has
// no treatment recorded yet and there is nothing to write from.
export const claimStoreDocSuggest = URL +'claims/store/documentation/suggest'

// Documentation ▸ Lab results. The laboratory side of a claim: which
// investigations were requested, which already have results, and which template
// each one maps onto.
//
// The claim carries the NHIS tariff's wording and the lab keeps its template
// under the hospital's, and the two are frequently different strings — see
// backend/claimLabPanel.js. `templates` feeds the dropdown that resolves an
// unmatched wording; `alias` remembers that answer so it is asked once.
//
// Results are NOT saved through these. They go through the laboratory's own
// saveLabResults, so a result entered on a claim is the same row the lab would
// have written and both screens see it.
// The marker on Entries ▸ Documentation: which of the four notes are written,
// how many investigations have results, and whether observations were taken.
// Counted from the stores that hold them, never from a cached flag. Vitals are
// null on an admission — see backend/claimDocStatus.js.
// ── NHIA's verdict on a submitted batch ────────────────────────────────────
// The portal returns an HTML import report after a submission. It is uploaded
// here, and the verdicts are then shown on the claims they belong to — so a
// rejected claim says WHY on the screen where it is edited.
//
// The verdicts are stored rather than the rules re-derived locally, because two
// local approximations were measured against a real report and were wrong by 33x
// and by 1,090 rows. See backend/nhiaImportReport.js.
export const nhiaReportPreview   = URL +'claims/nhia-report/preview'
export const nhiaReportImport    = URL +'claims/nhia-report/import'
export const nhiaReportBatches   = URL +'claims/nhia-report/batches'
export const nhiaReportSummary   = URL +'claims/nhia-report/summary'
// One claim's verdicts, for the editor. ?id= or ?ref=
export const claimStoreVerdict   = URL +'claims/store/verdict'
// The five rules that can be corrected mechanically. Preview always precedes the
// write — two of them change a patient's name and a membership number.
export const nhiaFixPreview      = URL +'claims/nhia-report/fix/preview'
export const nhiaFixApply        = URL +'claims/nhia-report/fix'

export const claimStoreDocStatus     = URL +'claims/store/documentation/status'

// ── An admission's documentation: the STAY, day by day ─────────────────────
// The four Documentation boxes are an out-patient encounter — one visit, one set
// of notes. A stay is written by four people at four rhythms: the admission
// assessment, the doctor's ward round each day, the nurse's observations several
// times a day, and the shift notes. This returns all of it, plus what was given
// and requested on each day, in one read.
//
// READ ONLY. The round belongs to the doctor who did it and the observation to
// the nurse who took it; a claims screen must not become a second place either
// can be authored. See backend/inpatientStay.js.
//
// Returns { stay: null, message } — not an error — for a claim that is not an
// admission, has no folder number, or has no visit date. Three different
// situations needing three different things done about them.
export const claimStoreInpatientDoc = URL +'claims/store/documentation/inpatient'

// A ward-round note DRAFTED for one day of the stay, from what that day already
// holds: the observations, the medicines on the chart and the tests requested.
// Drafted, never filed — the text comes back for a clinician to own, and nothing
// here writes to the ward record. See claimNoteAi.generateWardRound.
export const claimStoreInpatientSuggest = URL +'claims/store/documentation/inpatient/suggest'

// A WHOLE DAY of the stay, drafted — shaped by where the day sits in it. Day one
// is the admission, the middle is a review, the last day is the discharge and
// comes back with both discharge notes: the doctor's, and what the nurse tells
// the family on the way out. Falls back to the claim's own medicines and tests
// when nothing was charted on that particular day, and says which it used.
// Drafted, never filed. See claimNoteAi.generateStayDay.
export const claimStoreInpatientDay = URL +'claims/store/documentation/inpatient/day'

// Documentation ▸ Vitals. Reads the `vitals` row for the claim's patient on the
// claim's visit date, classifies each reading the way triage does, and returns
// the clinical context /generateVitals needs.
//
// There is no claims-side WRITE here on purpose: observations are saved through
// savePatienVitals, the triage screen's own endpoint, so a reading entered on a
// claim is the same row that appears on the patient's chart.
// Entries ▸ Past History. The patient's other attendances, from BOTH this
// hospital's visit register AND the member's other claims.
//
// The register alone was the old source, and it is empty for every imported
// member — they were never registered here. Their attendances live in the claims:
// 1,648 members in this database have more than one, up to ten.
export const claimStoreHistory       = URL +'claims/store/history'

export const claimStoreVitals        = URL +'claims/store/vitals'

export const claimStoreLabs          = URL +'claims/store/labs'
export const claimStoreLabPanel      = URL +'claims/store/labs/panel'
export const claimStoreLabTemplates  = URL +'claims/store/labs/templates'
export const claimStoreLabAlias      = URL +'claims/store/labs/alias'
export const claimStoreLabSuggest    = URL +'claims/store/labs/suggest'

// Saving the Member Details card. PUT with ?id= and ?source=; the body is a patch
// and the backend reads only its own whitelist from it (claimStore.BIO_FIELDS).
// Responds with the RE-READ claim, not an echo of the patch, so the screen shows
// what the database accepted rather than what was typed.
export const claimStoreBio = URL +'claims/store/bio'

// What a save would imply, asked before committing to it. Read-only. The visit
// date decides which month a claim is counted in, and a typed-in claim's folder
// number is what its medications and diagnoses are matched on — so those get named
// in the confirmation rather than discovered afterwards.
export const claimStoreBioPreview = URL +'claims/store/bio/preview'

// Putting a claim's service back in agreement with its own rows: the fix for an
// admission billed on an out-patient tariff, and for a principal that was never
// flagged. POST { ids: [], dryRun }. Derived from the claim's highest-tariff
// procedure, else its principal diagnosis — never invented, so a claim carrying
// nothing but OPD codes comes back `unfixable` instead of being given one.
//
// DRY RUN UNLESS dryRun IS EXPLICITLY false. This acts on a whole selection and
// there is no undo, so the before/after is shown first.
export const claimStoreRepair = URL +'claims/store/repair'

// ── One claim's specialty, settled when it is opened ───────────────────────
// The specialty code and its description, where the claim's own service gives
// exactly one answer: MEDI31A belongs to MEDI, so a claim billed on MEDI31A and
// recorded as OBGY is corrected without asking.
//
// SEPARATE FROM /repair, and hospital-side only. /repair reads
// `source: 'imported'` and takes integer ids, so it can never act on a flat
// claim — which is why the "Use Repair to correct it" hint on those claims did
// nothing at all. See backend/claimStore.settleSpecialty.
//
// NOT a dry run by default: one claim, one derived field, and the officer is
// looking at it. The editor calls this once per claim on open.
export const claimStoreSettleSpecialty = URL +'claims/store/claim/settle-specialty'

// ── Delete ONE claim, on either model ──────────────────────────────────────
// DELETE with ?id=&source=. Replaces the split that sent imported claims to
// IT / ICT ▸ Claims XML Import: an officer removing one duplicate no longer has
// to delete a whole batch to do it.
//
// What it removes differs by model, and the difference matters:
//   imported   the claim AND its own rows — diagnoses, procedures, medicines,
//              investigations, service lines, status history (all cascade)
//   facility   the claim_information row ONLY. The ward records — medication,
//              doctors_analysis, doctors_procedure_, investigation — are the
//              hospital's clinical notes and survive, so the claim can be
//              raised again from the same visit.
// See backend/claimStore.deleteClaim.
export const claimStoreDeleteClaim = URL +'claims/store/claim'

// ── Renaming a catalogue entry ─────────────────────────────────────────────
// The setup screens could edit a diagnosis's tariff, ICD, G-DRG, age band and
// specialty but not its NAME — that was write-once, fixed when the row was
// created.
//
// Renames EVERY record under that name, not one insurer's row: the setup screen
// lists these by name, so renaming a single record would split one entry into
// two. The claims-side picker reads these same tables, so a rename is visible
// there as soon as the catalogue cache turns over.
export const renameDiagnosis = URL +'renameDiagnosis'
export const renameProcedure = URL +'renameProcedure'

// ── Claim validation rules (Claims → Claim Rules) ──────────────────────────
// The configurable format rules behind the "wrong format" checks in the
// Advanced Filter: how long a membership number or CCC must be, and which
// characters it may contain, per insurance scheme. One endpoint, three verbs —
// GET everything the screen needs, PUT one rule, DELETE a scheme's override so
// it falls back to the default. See backend/claimFieldRules.js.
export const claimRules = URL + 'claims/rules'

// Dose units, per DRUG rather than per claim. NHIA refuses a medicine line with
// no dose unit, and the same drug is missing its unit on every claim carrying it
// — so GET lists the medications (with a suggested value derived from the drug's
// own strength or name) and POST applies what was typed to every affected line
// in the month. DRY RUN unless dryRun is explicitly false.
export const claimStoreDoseUnits = URL +'claims/store/dose-units'

// Options for the SERVICE dropdown. ?age= in years and ?attendance=, because the
// NHIS booklet splits many services at 12 years — under that is a child service,
// 12 and over an adult one. Served from the NHIS tariff book once that import has
// been run, and from the G-DRG catalogue until then.
export const claimStoreServices = URL +'claims/store/services'
//  The same endpoint the claim editor's Service dropdown reads, used by Condition
//  Templates to pick the service a template sets. It answers the four NHIA attendance
//  codes in the same response, so the template screen needs no second call for them.

// Procedures on one claim. The catalogue is procedure_tarf, priced per scheme, so
// the claim's insurer is part of the lookup. `dates` answers which days a
// procedure may be dated to: the visit day for an OPD attendance, every day of
// the stay for an admission. The row endpoint is one URL for add / edit / remove.
export const claimStoreProcedureTariff = URL +'claims/store/options/procedure-tariff'
export const claimStoreProcedureDates  = URL +'claims/store/procedure/dates'
export const claimStoreProcedure       = URL +'claims/store/procedure'
//  The PRINCIPAL of a long admission, chosen from the tariff book. One call that
//  writes the row into the claim's own procedures or diagnoses AND sets the
//  specialty from the book — the two must not come apart, or the claim names a
//  principal it does not carry. See the route's own header.
export const claimStorePrincipal       = URL +'claims/store/principal'

// Diagnoses on one claim. The catalogue is diagnosis_tarf where it is loaded —
// priced per scheme, carrying the G-DRG — and the ICD-10 reference list otherwise.
export const claimStoreDiagnosisTariff = URL +'claims/store/options/diagnosis-tariff'
export const claimStoreDiagnosis       = URL +'claims/store/diagnosis'
// Whether a catalogue entry the setup screen wrote will ever be offered on a
// claim, and if not, the likeliest reason. Runs the real picker, per scheme and
// per age band. Read-only — see catalogueVisibility in claimStore.js.
export const catalogueVisibility       = URL +'claims/store/catalogue-visibility'
// ── The clinical review ─────────────────────────────────────────────────────
//  Does the treatment on each claim fit the condition billed? A month is minutes
//  of work, so it is a JOB: POST to start one, GET/DELETE `${job}/${id}` to watch
//  or stop it. See backend/aiClaimReview.js for what it asks and what it refuses.
export const claimAiReview             = URL +'claims/store/ai-review'
export const claimAiReviewJob          = URL +'claims/store/ai-review'
//  One claim's stored answer, for the warning panel at the top of the editor.
export const claimAiReviewOf           = URL +'claims/store/ai-review-of'

// Investigations on one claim. The catalogue is lab_prices + scan_price — the same
// tables /loadLabs reads — priced per scheme and keyed on the test's name, because
// most rows carry no G-DRG.
export const claimStoreInvestigationTariff = URL +'claims/store/options/investigation-tariff'
export const claimStoreInvestigation       = URL +'claims/store/investigation'

// Medications on one claim. The catalogue is store_pro — the table
// /loadMedicationsCalim reads — priced per scheme and keyed on the drug's name.
export const claimStoreMedicationCatalogue = URL +'claims/store/options/medication-catalogue'
export const claimStoreMedication          = URL +'claims/store/medication'
// The last time this drug was prescribed to a patient of this age group, so the
// prescription fills itself in from practice rather than being typed from scratch.
export const claimStoreMedicationPattern   = URL +'claims/store/medication/pattern'

// ── One catalogue entry, and repairing it at the root ────────────────────────
//  Opened from the billed-content filter, where an officer can see that a code or
//  a name is wrong across hundreds of claims. Three calls, and the order is the
//  safety design: read what is there, preview what a change would do with the
//  exact counts, then apply — and the apply refuses a preview whose figures have
//  moved. See backend/catalogueEntry.js.
// ── Admissions billed on an out-patient G-DRG ───────────────────────────────
//  One answer per DIAGNOSIS, applied to every claim carrying it. The catalogue
//  holds Malaria as OPDC06A for a consultation and MEDI28A for an admission, and an
//  upload put the out-patient code on admissions' diagnoses. Preview groups the
//  449 offending rows into 21 questions; apply writes one answer to every row.
//  See backend/gdrgRecode.js.
export const claimStoreDiagnosisGdrgPreview = URL +'claims/store/diagnosis-gdrg/preview'
export const claimStoreDiagnosisGdrgApply   = URL +'claims/store/diagnosis-gdrg/apply'

export const claimStoreCatalogueEntry        = URL +'claims/store/catalogue-entry'
export const claimStoreCatalogueEntryPreview = URL +'claims/store/catalogue-entry/preview'
export const claimStoreCatalogueEntryRepair  = URL +'claims/store/catalogue-entry/repair'
export const updatePatientCInfo = URL +'updatePatientCInfo'
export const saveServiceProvidedCalim = URL +'saveServiceProvidedClaim'
// The claim's service / attendance / specialty header, and its diagnoses and
// procedures. Repointed at the store for the same reason as the rest: the flat
// versions read claim_information + diagnosis + doctors_analysis +
// doctors_procedure_, none of which an imported NHIA batch writes to, so on a
// bureau install every one of these panels came back empty.
export const servicesTodaycl = URL +'claims/store/service'
export const loadPatientDiagnosisclam = URL +'claims/store/clinical'
export const saveOrUpdateDiagnosisDocumetingClami = URL +'saveOrUpdateDiagnosisDocumetingClami'
export const saveOrUpdateProcedureDocumetingClami = URL +'saveOrUpdateProcedureDocumetingClami'
export const loadPatientLabsclim = URL +'loadPatientLabsclim'
export const saveOrUpdateLabsClami = URL +'saveOrUpdateLabsClami'
export const loadPatientScansclam = URL +'loadPatientScansclam'
export const saveOrUpdateScansClami = URL +'saveOrUpdateScansClami'
export const loadAvailableScanscilm = URL +'loadAvailableScanscilm'
export const loadMedicationsCalim = URL +'loadMedicationsCalim'
export const deleteMedicationclam = URL +'deleteMedicationclam'
export const claimyears = URL +'claimyears'
export const claimsmonthly = URL +'claimsmonthly'
export const claimsdetails = URL +'claimsdetails'
// What is actually IN a month — the diagnoses, procedures, medications and
// services present, each with how many CLAIMS carry it. Feeds the Claims Menu's
// Advanced Filter pick-lists. Takes the same scoping params as /claimsdetails, so
// the counts in the dialog reconcile with the list behind it.
export const claimsDetailsFacets = URL + 'claimsdetails/facets'

// Multi Vet — the claim editor's own work (diagnoses, procedures, lab/scan,
// medications) applied to a filtered set of claims. Preview writes nothing and
// reports per claim; the commit loops the SAME claimStore writers the single-claim
// editor uses, one claim at a time, and records the run. A run spanning more than
// one facility is refused.
// What the CHOSEN claims already contain — patient, visit, and every diagnosis,
// procedure, test and drug on each — read before anything is applied so the
// selection can be reviewed rather than trusted as a count.
// NHIA e-Claims XML, generated from the NORMALISED claim model and scoped by
// facility, month, date range and attendance. Returns the file as an attachment.
export const claimsXmlExport = URL + 'claims/export/xml'
export const claimsMultiVetSelection = URL + 'claims/multivet/selection'
export const claimsMultiVetPreview = URL + 'claims/multivet/preview'
export const claimsMultiVet        = URL + 'claims/multivet'
export const claimsMultiVetHistory = URL + 'claims/multivet/history'
//  A whole ROUTINE in one pass — a basket holding diagnoses, labs, drugs and
//  procedures together, applied once instead of four separate single-section runs.
export const claimsMultiVetBatch    = URL + 'claims/multivet/batch'
//  Saved baskets. A routine is a basket you got right once; every month after, it
//  is picked from a list rather than retyped from memory.
export const claimsMultiVetRoutines = URL + 'claims/multivet/routines'

// ── Condition templates ─────────────────────────────────────────────────────
//  "For THIS condition, in THIS kind of patient, give THIS." Authored up front out of
//  the facility's own priced catalogues.
//
//  `check` is the same validation the save runs first, called as the template is built
//  so the age and sex refusals appear while there is still something to change. A form
//  that decided for itself what was allowed would be a second opinion, and the drifted
//  half would be the one letting a wrong template through.
//
//  NOT behind the Clinical Templates licence — see routes/conditionTemplates.js.
export const conditionTemplates     = URL + 'claims/condition-templates'
export const conditionTemplateCheck = URL + 'claims/condition-templates/check'
export const conditionTemplate      = (id) => URL + `claims/condition-templates/${id}`

//  ── PUTTING A TEMPLATE ONTO CLAIMS ──────────────────────────────────────────
//  templateApplyCheck judges every claim and WRITES NOTHING: each one is measured
//  against its own patient's date of birth, gender and attendance, so the officer sees
//  which claims can take the template before any of them do.
//
//  templateApply writes — and defaults to a dry run, because 'replace' deletes the
//  claim's existing entries. Send dryRun: false to mean it.
export const templateApplyCheck = URL + 'claims/template-apply/check'
export const templateApply      = URL + 'claims/template-apply'

export const specialtycodes = URL +'specialtycodes'
export const deleteclaim = URL +'deleteclaim'
export const bulkUpdateRequisitions = URL +'bulkUpdateRequisitions'
export const claimsDetailsall = URL +'claimsDetailsall'
export const diagnosis_tarf = URL +'diagnosis_tarf'
export const procedureReport = URL +'procedure_tarf'
export const investigationReport = URL +'investigationReport'
export const medicationReport = URL +'medicationReport'
export const loadServices = URL +'loadServices'
export const getServiceInsurances = URL +'getServiceInsurances'
export const updateInsuredService = URL +'updateInsuredService'
export const deleteInsuredService = URL +'deleteInsuredService'
export const saveNewService = URL +'saveNewService'
export const moveServicesToInsurancedb = URL +'moveServicesToInsurance'

export const getDiagnosisInsurances = URL +'getDiagnosisInsurances'
export const updateInsuredDiagnosis = URL +'updateInsuredDiagnosis'
export const deleteInsuredDiagnosis = URL +'deleteInsuredDiagnosis'
export const saveNewDiagnosis = URL +'saveNewDiagnosis'
export const loadDiagnoses = URL +'loadDiagnoses'
export const bulkApplyDiagnosisInsurance = URL +'bulkApplyDiagnosisInsurance'

export const loadProcedures = URL +'loadProcedures'
export const getProcedureInsurances = URL +'getProcedureInsurances'
export const updateInsuredProcedure = URL +'updateInsuredProcedure'
export const deleteInsuredProcedure = URL +'deleteInsuredProcedure'
export const saveNewProcedure = URL +'saveNewProcedure'
export const bulkApplyProcedureInsurance = URL +'bulkApplyProcedureInsurance'

export const loadLabCategoriesbd  = URL +'loadLabCategoriesbd'
export const loadLabsByCategory  = URL +'loadLabsByCategory'
 
export const getLabInsurances  = URL +'getLabInsurances'
export const updateInsuredLab  = URL +'updateInsuredLab'
export const deleteInsuredLab  = URL +'deleteInsuredLab'
export const saveNewLab = URL +'saveNewLab'
export const bulkApplyLabInsurance  = URL +'bulkApplyLabInsurance'
export const medicationStock  = URL +'medicationStock'
export const moveLabToInsurancedb = URL + 'moveLabToInsurance';

// Scan Tariff Setup (mirrors Lab Tariff Setup)
export const loadScanCategoriesbd    = URL + 'loadScanCategoriesbd';
export const getScanInsurances       = URL + 'getScanInsurances';
export const updateInsuredScan       = URL + 'updateInsuredScan';
export const deleteInsuredScan       = URL + 'deleteInsuredScan';
export const saveNewScan             = URL + 'saveNewScan';
export const bulkApplyScanInsurance  = URL + 'bulkApplyScanInsurance';
export const moveScanToInsurancedb   = URL + 'moveScanToInsurance';


export const loadPettyExpenses  = URL +'loadPettyExpenses'
export const savePettyExpense  = URL +'savePettyExpense'
export const updatePettyExpense  = URL +'updatePettyExpense'
export const deletePettyExpense  = URL +'deletePettyExpense'

  
export const approvePettyExpense = URL + 'approvePettyExpense'
export const rejectPettyExpense  = URL + 'rejectPettyExpense'


//SMS (SMS Online GH gateway — see backend/services/SmsService.js)

// Composer & recipient pickers
export const smsInsuranceTypes  = URL + 'smsInsuranceTypes'
export const smsMonths          = URL + 'smsMonths'
export const smspatients        = URL + 'smspatients'
export const smsReligions       = URL + 'smsreligions'

// Send + history + gateway health
export const SmsSend            = URL + 'smssend'         // POST { recipients, message, kind? }
export const smsLog             = URL + 'smsLog'          // GET  ?status=&kind=&search=&limit=
export const smsBalance         = URL + 'smsBalance'      // GET

// Provider settings (admin only) + registration welcome trigger
export const smsSettings        = URL + 'sms/settings'    // GET / PUT
export const smsWelcome         = URL + 'sms/welcome'     // POST { tel, patientName, patientId, facilityName }

// Appointment reminder — SMS Online GH v5 does not support scheduled
// delivery, so this now sends IMMEDIATELY. The name is kept so
// existing call sites (Doctors/OutPatient, Claims/OutPatient) work.
export const scheduleAppointmentSms = URL + 'sms/appointment'  // POST { tel, patientName, appointmentDate, appointmentTime, appointmentType, facilityName }


// Writen Off 
export const saveWriteOff   = URL + 'saveWriteOff'
export const listWriteOff   = URL + 'listWriteOff';
export const updateWriteOff = URL + 'updateWriteOff';
export const deleteWriteOff = URL + 'deleteWriteOff';
// Admin approval panel
export const loadAllWriteOffRequests = URL + 'loadAllWriteOffRequests';
export const approveWriteOff         = URL + 'approveWriteOff';
export const rejectWriteOff          = URL + 'rejectWriteOff';

// id card 

export const getCardColors   = URL + 'getCardColors'
export const saveCardColors  = URL + 'saveCardColors';

export const getCardPrinterType  = URL + 'getCardPrinterType';   // GET
export const saveCardPrinterType = URL + 'saveCardPrinterType';  // PUT

export const getInsurancePartners    = URL + 'getInsurancePartners';     // GET  — active only (for card)
export const getAllInsurancePartners  = URL + 'getAllInsurancePartners';   // GET  — all (for admin)
export const addInsurancePartner     = URL + 'addInsurancePartner';       // POST
export const updateInsurancePartner  = URL + 'updateInsurancePartner';    // PUT
export const deleteInsurancePartner  = URL + 'deleteInsurancePartner'; 

export const getIdCardAmount  = URL + 'getIdCardAmount'; 
export const saveIdCardAmount  = URL + 'saveIdCardAmount'; 
 
export const checkIdCardCharge  = URL + 'checkIdCardCharge'; 


//Hospital Claims Documentation 

export const outpatientMonthsdb = URL + 'outpatientMonths';
export const outpatientDatesdb = URL + 'outpatientdates';
export const outpatientPatientsdb = URL + 'outpatientPatients';


//
export const generateNote = URL + 'generateNote';
export const generateNurseNote = URL + 'generateNurseNote';
export const generateVitals = URL + 'generateVitals';


// ── Install profile ─────────────────────────────────────────────────────────
// Whether this installation is a hospital ('facility') or a Gigatt Apex claims
// bureau, and which departments it gets. Deliberately NOT under /api — it is
// read during boot alongside setup/status, before any department has mounted.
export const installProfile = URL + 'install/profile'


// ── IT / ICT department ─────────────────────────────────────────────────────
// Facility Onboarding + NHIS Imports, ported from the standalone Gigatt
// project. Names match the source's BaseURL exactly so the two components
// compile unmodified — do not rename them.
export const adminClientFacilities       = URL + 'api/admin/client-facilities'
export const adminClientFacilityById     = (id) => URL + `api/admin/client-facilities/${id}`
export const adminClientFacilityEntitle  = (id) => URL + `api/admin/client-facilities/${id}/entitlements`
export const adminClientFacilityCccVerify   = (id) => URL + `api/admin/client-facilities/${id}/ccc/verify`
export const adminClientFacilityCccGenerate = (id) => URL + `api/admin/client-facilities/${id}/ccc/generate`

// The NHIS booklet PDFs. Preview never touches the database; commit runs one
// atomic transaction. Both need python3 + pypdf on the API host.
export const adminNhisImportPreview = URL + 'api/admin/nhis-import/preview'
export const adminNhisImportCommit  = URL + 'api/admin/nhis-import/commit'

export const nhisFacilityLevels     = URL + 'api/nhis/facility-levels'

// The NHIS tariff SPREADSHEETS, which is a different job from the booklets
// above: these populate insured_services, the table billing charges from.
// The browser parses the .xlsx with exceljs and posts the raw cells, so neither
// endpoint needs Python or a spreadsheet library on the API host. Preview reads
// the table and reports what would change; commit writes in one transaction.
// One builder rather than three constants per sheet type: a release has four
// sheets and they all use the same route shape, so `kind` is the only thing that
// varies. `imports` is the named record of every sheet ever loaded — it survives
// the commit and the session, and is how a facility answers "which tariff are we
// billing on?" long after the import screen was closed.
export const nhisCatalogueImportUrls = (kind) => ({
  preview: URL + `api/nhis-catalogue/${kind}/preview`,
  commit:  URL + `api/nhis-catalogue/${kind}/commit`,
  history: URL + `api/nhis-catalogue/${kind}/imports`,
  record:  (id) => URL + `api/nhis-catalogue/${kind}/imports/${id}`,
})

// Claims XML Import. Preview parses only and writes nothing; commit returns a
// job id immediately and the worker runs in the background, so the frontend
// polls claimsImportJob for progress rather than waiting on the request.
export const claimsImportPreview   = URL + 'api/claims/import/preview'
export const claimsImportCommit    = URL + 'api/claims/import/commit'
export const claimsImportJob       = (id) => URL + `api/claims/import/jobs/${id}`
// Every batch imported so far, newest first. Added for this platform — the
// source only ever fetched the one job it had just started.
export const claimsImportHistory   = URL + 'api/claims/import/history'
// What is inside one batch — the expanded row. Paginated; a real batch is
// thousands of claims.
export const claimsImportBatchClaims = (id) => URL + `api/claims/import/history/${id}/claims`
// Removes a batch and its claims. Refuses by default when the batch contains
// claims already submitted/approved/paid; ?force=1 overrides.
export const claimsImportBatchDelete = (id, force) =>
  URL + `api/claims/import/history/${id}` + (force ? '?force=1' : '')

// Facility logos come back as a server-relative path (/uploads/…), so they are
// joined onto the API origin rather than the frontend's.
export const assetUrl = (p) => (p ? URL.replace(/\/$/, '') + p : null)


// ── Clinical Templates department (licensed add-on) ─────────────────────────
// Every route below 403s unless this facility holds a templates_license row in
// the central licence database. `templatesLicense` is the one exception — it
// sits outside the gate so the UI can decide whether to show the department at
// all, rather than rendering a menu entry that fails on click.
// Names are IDENTICAL to the standalone Gigatt project's, so the ported
// department's ten components compile unmodified. Do not "tidy" them — every
// rename here is a change to a file that was deliberately copied verbatim.
export const templatesLicense      = URL + 'api/templates/license'

export const templateConditions    = URL + 'api/templates/conditions'
export const templateCondition     = (id) => URL + `api/templates/conditions/${id}`
export const templateChild         = (id, cat) => URL + `api/templates/conditions/${id}/${cat}`
export const templateChildRow      = (id, cat, rowId) => URL + `api/templates/conditions/${id}/${cat}/${rowId}`
export const templateSuggest       = (id, cat) => URL + `api/templates/conditions/${id}/${cat}/suggest`
export const templatePending       = (id) => URL + `api/templates/conditions/${id}/pending`
export const templatePendingAccept = (id, pid) => URL + `api/templates/conditions/${id}/pending/${pid}/accept`
export const templatePendingReject = (id, pid) => URL + `api/templates/conditions/${id}/pending/${pid}/reject`

export const templateSources           = URL + 'api/templates/sources'
export const templateAttachedDiagnoses = (gdrgId) => URL + `api/templates/sources/procedure/${gdrgId}/attached-diagnoses`
export const templateSubProcedures     = (gdrgId) => URL + `api/templates/sources/procedure/${gdrgId}/sub-procedures`
export const templateDiagnosisGdrgs    = (diagId) => URL + `api/templates/sources/diagnosis/${diagId}/gdrgs`

// Documentation Sets — matched clinical narratives (uses category 'narratives')
export const templateNarratives        = (id) => URL + `api/templates/conditions/${id}/narratives`
export const templateNarrativeRow      = (id, rowId) => URL + `api/templates/conditions/${id}/narratives/${rowId}`
export const templateNarrativeSuggest  = (id) => URL + `api/templates/conditions/${id}/narratives/suggest`

// Labs attached to a narrative — investigation catalogue is imported-only.
export const templateInvestigations    = URL + 'api/templates/sources/investigations'
export const templateNarrativeLabs         = (narrId) => URL + `api/templates/narratives/${narrId}/labs`
export const templateNarrativeLabRow       = (narrId, labId) => URL + `api/templates/narratives/${narrId}/labs/${labId}`
export const templateNarrativeLabsSuggest  = (narrId) => URL + `api/templates/narratives/${narrId}/labs/suggest`

// Medications attached to a narrative — imported medicines list only.
export const templateMedicines               = URL + 'api/templates/sources/medicines'
export const templateNarrativeMeds           = (narrId) => URL + `api/templates/narratives/${narrId}/medications`
export const templateNarrativeMedRow         = (narrId, medId) => URL + `api/templates/narratives/${narrId}/medications/${medId}`
export const templateNarrativeMedsSuggest    = (narrId) => URL + `api/templates/narratives/${narrId}/medications/suggest`

// Scans attached to a narrative — imaging INVE codes only.
export const templateScans                   = URL + 'api/templates/sources/scans'
export const templateNarrativeScans          = (narrId) => URL + `api/templates/narratives/${narrId}/scans`
export const templateNarrativeScanRow        = (narrId, scanId) => URL + `api/templates/narratives/${narrId}/scans/${scanId}`
export const templateNarrativeScansSuggest   = (narrId) => URL + `api/templates/narratives/${narrId}/scans/suggest`
export const loadStaffNamesdb = URL + '/loadStaffNames';
 

//SOPS
export const loadAllSOPDocumentsdb = URL + 'loadAllSOPDocuments';
export const loadSOPDocumentByIddb = URL + 'loadSOPDocumentById';
export const createSOPDocumentdb = URL + 'createSOPDocument';
export const updateSOPDocumentdb = URL + 'updateSOPDocument';
export const deleteSOPDocumentdb = URL + 'deleteSOPDocument';


//MEDICAL hISTORY

export const getPatientVisitSummarydb  = URL + 'visitsummary';
export const getVisitFullDetailsdb     = URL + 'visitfulldetails';
export const getNurseNotesdb           = URL + 'nurseNotespatients';
export const getIPDDiagnosisNotesdb    = URL + 'ipddiagnosisnotes';
export const getIPDAdmissionNotesdb    = URL + 'ipdadmissionNotes';


export const visitVitalsdb  = URL + 'visitVitals';
export const visitNurseNotesdb     = URL + 'visitNurseNotes';
export const visitIPDDiagnosisdb           = URL + 'visitIPDDiagnosis';
export const visitIPDAdmissiondb    = URL + 'visitIPDAdmission';



export const uploadSopDocumentdb = URL+ `uploadSopDocument`;


// Human Resources
export const hrListEmployees    = URL + 'api/hr/employees';
export const hrCreateEmployee   = URL + 'api/hr/employees';
export const hrUpdateEmployee   = (id) => URL + `api/hr/employees/${id}`;
export const hrDeleteEmployee   = (id) => URL + `api/hr/employees/${id}`;
export const hrSummary          = URL + 'api/hr/summary';
export const hrGetSettings      = URL + 'api/hr/settings';
export const hrSaveSettings     = URL + 'api/hr/settings';

// Attendance (biometric device)
export const attendanceToday    = URL + 'api/attendance/today';
export const attendanceUnlinked = URL + 'api/attendance/unlinked';
export const attendanceLink     = URL + 'api/attendance/link';
export const attendanceDevices  = URL + 'api/attendance/devices';
export const attendanceReport   = URL + 'api/attendance/report';




















































































// Every requested test on one claim, suggested in one request. Returns rows that
// are ready to save — parameter, value, unit, range and the computed flag — but
// writes nothing: the laboratory's own /saveLabResults is what writes a result.
// Tests whose form is unmatched or ambiguous, and tests that already have
// results, come back in `skipped` with the reason.
export const claimStoreLabSuggestAll = URL +'claims/store/labs/suggest-all'

// Nursing observations for one day of a stay — three or four readings at the
// hours a ward rounds, banded to the patient's age and consistent with the
// condition and the day's place in the stay. Range-checked on the server before
// they come back. Suggested only: the ward's own /saveVitals is what writes one.
export const claimStoreInpatientVitals = URL +'claims/store/documentation/inpatient/vitals'

// THE PATIENT FOLDER, assembled in one request: the claim, the four encounter
// notes, the observations, the stay day by day, and every laboratory result with
// its ranges. Each part reports its own failure, so the printed document can say
// which section could not be read rather than presenting a gap as an absence.
// Read-only. Rendered by Claims/patientFolderPrint.js.
export const claimStoreFolder = URL +'claims/store/folder'
